import { useEffect } from 'react';

// Shopify adds 'headroom--unpinned' class to the header when the user scrolls down.
// This class is used to hide the nav menu when scrolling down so that the user can see more of the page.
// We need to adjust the padding of the page body to account for this change in height.
// This hook will keep the page body padding in sync with the header height.

export const useHeaderPadding = () => {
  useEffect(() => {
    const header = document.querySelector<HTMLElement>('#shopify-section-header');
    const pageBody = document.getElementById('page-body-container');
    if (!header || !pageBody) return;

    const adjust = (height: number) => {
      if (!header.classList.contains('headroom--unpinned')) {
        pageBody.style.paddingTop = `${height}px`;
      }
    };

    adjust(header.offsetHeight);

    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        adjust(entry.contentRect.height);
      }
    });
    observer.observe(header);

    return () => {
      observer.disconnect();
    };
  }, []);
};
